module.exports = __webpack_public_path__ + "a8a10a3e/img/settings-icon.121d9519.svg";